import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
    isResourceTypesLoading: false,
    isResourceLoading: false,
    isResourceGroupLoading: false,
    isTrainingClassesLoading: false,
    isResourceStatusesLoading: false,
    isSkillTypesLoading: false,
    isResourceCraftClassLoading: false,
    error: null,
    resources: null,
    resource_types: null,
    resource_groups: null,
    training_classes: null,
    resource_statuses: null,
    skillTypes: null,
    resourceCraftClass: null,
};

const slice = createSlice({
    name: 'resource',
    initialState,
    reducers: {
        // START LOADING
        startResourceTypesLoading(state) {
            state.isResourceTypesLoading = true;
        },
        startResourceLoading(state) {
            state.isResourceLoading = true;
        },
        startResourceGroupLoading(state) {
            state.isResourceGroupLoading = true;
        },
        startTrainingClassesLoading(state) {
            state.isTrainingClassesLoading = true;
        },
        startResourceStatusesLoading(state) {
            state.isResourceStatusesLoading = true;
        },
        startSkillTypesLoading(state) {
            state.isSkillTypesLoading = true;
        },
        startResourceCraftClassLoading(state) {
            state.isResourceCraftClassLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isResourceTypesLoading = false;
            state.isResourceLoading = false;
            state.isResourceGroupLoading = false;
            state.isTrainingClassesLoading = false;
            state.isResourceStatusesLoading = false;
            state.isSkillTypesLoading = false;
            state.isResourceCraftClassLoading = false;
            state.error = action.payload;
        },
        // SET RESOURCES TYPES
        setResourceTypes(state, action) {
            state.isResourceTypesLoading = false;
            state.resource_types = action.payload;
        },
        // SET RESOURCES
        setResource(state, action) {
            state.isResourceLoading = false;
            state.resources = action.payload;
        },
        // SET RESOURCE GROUPS
        setResourceGroup(state, action) {
            state.isResourceGroupLoading = false;
            state.resource_groups = action.payload;
        },
        // SET TRAINING CLASSES
        setTrainingClasses(state, action) {
            state.isTrainingClassesLoading = false;
            state.training_classes = action.payload;
        },
        // SET RESOURCE STATUSES
        setResourceStatuses(state, action) {
            state.isResourceStatusesLoading = false;
            state.resource_statuses = action.payload;
        },
        // GET SKILLTYPES
        setSkillTypes(state, action) {
            state.isSkillTypesLoading = false;
            state.skillTypes = action.payload;
        },
        // GET RESOURCECRAFTCLASS
        setResourceCraftClass(state, action) {
            state.isResourceCraftClassLoading = false;
            state.resourceCraftClass = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
export const {
    startResourceTypesLoading,
    startResourceLoading,
    startResourceGroupLoading,
    startTrainingClassesLoading,
    startResourceStatusesLoading,
    startSkillTypesLoading,
    startResourceCraftClassLoading,
    hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getResourceTypes() {
    return async () => {
        dispatch(slice.actions.startResourceTypesLoading());
        try {
            const response = await axios.get('/admin/resource/resource_types');
            dispatch(slice.actions.setResourceTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getResource(params = {}, fetchUrl = "/dropdown/resource/resources") {
    return async () => {
        dispatch(slice.actions.startResourceLoading());
        try {
            const response = await axios.get(fetchUrl, {
                params: params
            });
            dispatch(slice.actions.setResource(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvailableResource(params = {}, fetchUrl) {
    return async () => {
        dispatch(slice.actions.startResourceLoading());
        try {
            const response = await axios.get("/admin/resource/dropdown/available_resources", {
                params: params
            });
            dispatch(slice.actions.setResource(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvailableJobResource() {
    return async () => {
        dispatch(slice.actions.startResourceLoading());
        try {
            const response = await axios.get('/admin/job_master/available_resources');
            dispatch(slice.actions.setResource(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getAvailableTrainingResource(companyId = null) {
    return async () => {
        dispatch(slice.actions.startTrainingClassesLoading());
        try {
            const response = await axios.get('/admin/resource/training_class/available_resources', {
                params: {
                    company_id: companyId
                }
            });
            dispatch(slice.actions.setResource(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getResourceGroup() {
    return async () => {
        dispatch(slice.actions.startResourceGroupLoading());
        try {
            const response = await axios.get('/admin/resource/resource_groups');
            dispatch(slice.actions.setResourceGroup(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getTrainingClass() {
    return async () => {
        dispatch(slice.actions.startTrainingClassesLoading());
        try {
            const response = await axios.get('/admin/resource/training_classes');
            dispatch(slice.actions.setTrainingClasses(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function getResourceStatus() {
    return async () => {
        dispatch(slice.actions.startResourceStatusesLoading());
        try {
            const response = await axios.get('/admin/resource/resource_statuses');
            dispatch(slice.actions.setResourceStatuses(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSkillTypes() {
    return async () => {
        dispatch(slice.actions.startSkillTypesLoading());
        try {
            const response = await axios.get(`/admin/resource/skill_types`);
            dispatch(slice.actions.setSkillTypes(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getResourceCraftClass() {
    return async () => {
        dispatch(slice.actions.startResourceCraftClassLoading());
        try {
            const response = await axios.get('/admin/resource/resource_craft_classes');
            dispatch(slice.actions.setResourceCraftClass(response.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}